import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useStepResource(stepId, resourceId) {
  const [resource, setResource] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.steps.step_resources.show(stepId, resourceId))
      .then((response) => {
        setResource(response.data.data);
      });
  }, [stepId, resourceId]);

  return resource;
}
